import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
// import logger from "redux-logger";
import AuthReducer from "./reducers/authReducer";
import CategoryReducer from "./reducers/categoryReducer";
import BrandsReducer from "./reducers/brandsReducer";
import SkusReducer from "./reducers/skusReducer";
import RegionReducer from "./reducers/regionReducer";
import DemandDriverReducer from "./reducers/demandDriverReducer";
import PrimaryDashboardReducer from "./reducers/primaryDashboardReducer";
import DemandPlannerReducer from "./reducers/demandPlannerReducer";
import SecondaryDashboardReducer from "./reducers/secondaryDashboardReducer";
import ChannelReducer from "./reducers/channelReducer";
import ForecastDetailReducer from "./reducers/forecastDetailReducer";
import regionsGrowthReducer from "./reducers/regionsGrowthReducer";
import ChannelSaleReducer from "./reducers/channelSaleReducer";
import SecondarySaleEndSctock from "./reducers/secondarySale_endStock_Reducer";
import CoctRobReducer from "./reducers/coctrobReducer";
import StandPointReducer from "./reducers/standpointReducer";

import PromotionReducer from "./prat_reducers/gt/promotionReducer";
import ProductReducer from "./prat_reducers/gt/productReducer";
import GeoReducer from "./prat_reducers/gt/geoReducers";
import GtChannelReducer from "./prat_reducers/gt/gtChannelReducer";
import OutletReducer from "./prat_reducers/gt/outletReducer";
import DurationReducer from "./prat_reducers/gt/durationReducer";
import TemporaryReducer from "./prat_reducers/gt/temporaryReducer";
import CreatePromotionReducer from "./prat_reducers/promotion/createPromotionReducer";
import PromotionListReducer from "./prat_reducers/promotion/promotionListReducer";
import ApprovalReducer from "./prat_reducers/promotion/approvalReducer";
import ForcastReportReducer from "./reducers/forcastReportReducer";
import SegmentReducer from "./reducers/segmentReducer";
import UploadDpXlxReducer from "./reducers/uploadDPXlxReducer";
import DemandPlannerVersionReducer from "./reducers/demandPlannerVersionReducer";
import DownloadXlxReducer from "./reducers/downloadXlxReducer";
import CoreTypeReducer from "./reducers/coreTypeReducer";
import NotificationReducer from "./reducers/notificationReducer";
import ActivityPlanReducer from "./prat_reducers/activityPlan/activityPlanReducer";
import AccrualReportReducer from "./prat_reducers/accrualReport/accrualReportReducer";
import PreAndPostOpsoReducer from "./prat_reducers/preAndPostOpso/preAndPostOpsoReducer";
import PratDashboardReducer from './prat_reducers/pratDashboard/pratDashboardReducer';
import BaselineTotalDemandReducer from './reducers/baselineTotalDemandReducer';

const rootReducer = combineReducers({
  AuthReducer,
  CategoryReducer,
  BrandsReducer,
  SkusReducer,
  RegionReducer,
  DemandDriverReducer,
  PrimaryDashboardReducer,
  DemandPlannerReducer,
  SecondaryDashboardReducer,
  ChannelReducer,
  PromotionReducer,
  ProductReducer,
  GeoReducer,
  GtChannelReducer,
  OutletReducer,
  DurationReducer,
  TemporaryReducer,
  CoctRobReducer,
  ForecastDetailReducer,
  regionsGrowthReducer,
  ChannelSaleReducer,
  SecondarySaleEndSctock,
  CoreTypeReducer,
  StandPointReducer,
  // Prat1Reducer,
  SegmentReducer,
  ForcastReportReducer,
  UploadDpXlxReducer,
  DemandPlannerVersionReducer,
  DownloadXlxReducer,
  NotificationReducer,
  CreatePromotionReducer,
  PromotionListReducer,
  ApprovalReducer,
  ActivityPlanReducer,
  AccrualReportReducer,
  PreAndPostOpsoReducer,
  PratDashboardReducer,
  BaselineTotalDemandReducer
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  // composeEnhancers(applyMiddleware(thunk,logger))
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
